import { Badges, H4, H5, P } from "../../../../AbstractElements";
import { MyResolutions, MyResolutionsFor2024, Resolutions } from "../../../../utils/Constant";

const ResolutionTimeline = () => {
  const ResolutionText = "I'm determined to streamline, organism, systematism, realign, and embrace life in 2024.";

  return (
    <div className="cd-timeline-block">
      <div className="cd-timeline-img cd-movie bg-danger">
        <i className="icon-agenda" />
      </div>
      <div className="cd-timeline-content">
        <div className="timeline-wrapper">
          <Badges color="warning">{Resolutions}</Badges>
        </div>
        <H4 className="m-0 vertical-timeline-element-subtitle">{MyResolutionsFor2024}</H4>
        <P className="mb-0">{ResolutionText}</P>
        <div className="time-content pt-2">
          <i className="icon-write"></i>
          <H5>{MyResolutions}</H5>
        </div>
        <span className="cd-date">December 31 2024 </span>
      </div>
    </div>
  );
};

export default ResolutionTimeline;
